// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import Swiper from 'swiper/swiper-bundle';

const fragments = {
  SWIPER: '[data-fragment="FullpageGallery.swiper"]',
  PREV: '[data-fragment="FullpageGallery.prev"]',
  NEXT: '[data-fragment="FullpageGallery.next"]',
  PAGINATION: '[data-fragment="FullpageGallery.pagination"]',
};

export default class FullpageGallery extends WebComponent {
  constructor (props) {
    super(props);
  }

  didMount() {
    this.swiperElement = this.element.querySelector(fragments.SWIPER);
    this.swipers = new Swiper(this.swiperElement, {
      speed: 500,
      loop: true,
      slidesPerView: 3,
      centeredSlides: true,
      navigation: {
        nextEl: fragments.NEXT,
        prevEl: fragments.PREV,
      },
      pagination: {
        el: fragments.PAGINATION,
        clickable: true,
      },
    });
  }
  willUnMount() {}
  update() {}
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/FullpageGallery.js